import { useSettings } from '@/data/Settings';

export const ENABLE_EDD_PLP_STORECONF_KEY = 'EDD_PLP_ENABLED';

export const isEddPlpEnabled = (userData: Record<string, string> | undefined): boolean =>
	userData?.[ENABLE_EDD_PLP_STORECONF_KEY]?.trim().toLowerCase() !== 'false';

export const useIsEddPlpEnabled = (): boolean => {
	const { settings } = useSettings();
	return isEddPlpEnabled(settings.userData);
};
